import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Link, Outlet } from '@tanstack/react-router';
import { twMerge } from 'tailwind-merge';

import { ButtonLink } from '@repo/components/button-link';

import { routesByPath } from '~/config/routes.ts';
import { ContentHeader } from '~/features/content-header/content-header.tsx';
import { queryOrganizationById } from '~/services/authorization/authorization.ts';

export const Route = createFileRoute('/(user-mgmt)/organization/$org/user-mgmt')({
  loader: async ({ context: { queryClient }, params: { org } }) => {
    return queryClient.ensureQueryData(queryOrganizationById(org));
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { org } = Route.useParams();
  const organization = useSuspenseQuery(queryOrganizationById(org)).data;

  return (
    <div className="flex flex-col items-start gap-6 pb-6">
      <div className="flex w-full flex-wrap items-start justify-between gap-4">
        <div className="flex flex-col gap-1">
          <ContentHeader>
            User management
          </ContentHeader>
          <p>
            Manage users and roles in
            {' '}
            {organization.name}
          </p>
        </div>
        <ButtonLink
          to="/organization/$org/user-mgmt-guide"
          params={p => ({ org: p.org ?? '' })}
          variant="soft"
          color="primary"
          size="sm"
          className="w-fit"
        >
          How user management works
        </ButtonLink>
      </div>
      <nav className="w-full border-b border-secondary-200">
        <ul className="flex gap-4">
          {[
            routesByPath['/organization/$org/user-mgmt/users'],
            routesByPath['/organization/$org/user-mgmt/service-accounts'],
            routesByPath['/organization/$org/user-mgmt/roles'],
          ].map(route => (
            <li key={route.path}>
              <Link
                to={route.path}
                params={p => ({ org: p.org ?? '' })}
                className={twMerge(
                  'flex items-center justify-center',
                  'py-2 px-4 leading-none rounded',
                  'hover:bg-primary-100',
                )}
                activeProps={{ className: 'border-b-2 border-b-primary-700 rounded-b-none' }}
              >
                {route.title}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <Outlet />
    </div>
  );
}
